module.exports = __webpack_public_path__ + "static/img/licence.cee7724.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/licence.jpg
// module id = 9QZG
// module chunks = 1